import { createEvent } from 'effector'

export const resetMessageForm = createEvent<void>()

/**
 * for chat-only
 */
export const resetAcceptedGdpr = createEvent<void>()

/**
 * for chat-only: текст «согласие предоставлено» ровно в том виде, в каком его
 * увидел нажавший кнопку кандидат. Единственный момент, когда этот текст
 * достоверен, — момент нажатия: перевод грузится по сети, и позже `t` вернёт
 * ту же строку уже на другом языке
 */
export const consentGrantedShown = createEvent<string>()
